// extracted by mini-css-extract-plugin
export default {"buttonFhirIcon":"TooltipIcon_buttonFhirIcon__y-4P6","tooltipBadge":"TooltipIcon_tooltipBadge__KQaCI","greyOut":"TooltipIcon_greyOut__V4ycg"};